// extracted by mini-css-extract-plugin
module.exports = {"page":"_404-module--page--2p3Ka","fontsLoading":"_404-module--fonts-loading--dA6Bi"};